
import mixin from "./mixin";
import { Vue, Component, Mixins, Prop, PropSync } from "vue-property-decorator";
import * as modals from "@/lib/modals";
import { SystemModule, OrderModule, CompanyModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";
import notifications from "../../../lib/notifications";
const orderModule = getModule(OrderModule);

@Component({ name: modals.consigneeEntryModal })
export default class AddressVerificationStatusModal extends Vue {
  isVisible: boolean = false;
  addressVerificationStatusId : Number = 1;
  newStatusId: number = 1;
  newAddress: any = null;
  isLoading = false;

  @Prop()
  statusId: number;

  async saveModal() {
    let newId : Number = 0;

    if(this.statusId == 1 || this.statusId == 3 || this.statusId == 4)
      newId = 2;

    if(this.statusId == 2)
      newId = 1;
    
    this.isLoading = true;
    await this.sendChanges(newId);
    this.isLoading = false;

    this.hideModal()
    orderModule.updateAddressVerificationStatusId(newId);
  }

  async denyAndSaveModal() {
    this.isLoading = true;
    await this.sendChanges(4);
    this.isLoading = false;

    this.hideModal()
    orderModule.updateAddressVerificationStatusId(4);
  }

  async getAddress() {
    if(this.newAddress == null) {
      this.isLoading = true;
      var results = await orderModule.getAddressChangeRequest(orderModule.currentOrder.headerNumber)
      this.newAddress = results.data;
      this.isLoading = false;
    }
  }

  getStatusName() {
    if(this.statusId == 2)
      return "Unverify Address"

    if(this.statusId == 1)
      return "Verify Address"
  
      if(this.statusId == 3)
        return "Approve"  

      if(this.statusId == 4)
        return "Verify Address"  
  }

  hideModal() {
    this.isVisible = false;
  }

  showModal() {
    if(this.statusId==3)
      this.getAddress();

    this.isVisible = true;
    this.addressVerificationStatusId = this.statusId;
  }

  async sendChanges(newId: Number) {
    const headerNumber = orderModule.currentOrder.headerNumber;


    try {
      let response = await orderModule.updateAddressVerification({orderNumber: headerNumber, addressVerificationStatusId: newId});

      if(this.statusId === 3 && newId !==4 ) {
        orderModule.changeCurrentOrderParty({ party: response.data.party, type: "consignee"});
      }
    } catch (ex) {
      notifications.error("Address Verification Status", "Failed to update statue", ex);
    }
  }
}
